module.exports = __webpack_public_path__ + "img/chicken_0327 1.3f84875b.png";